export const isLumpSumWithdrawalAmountUnderLimit = (withdrawalAmount) => {
  return withdrawalAmount < 10000;
};

export const isRegularWithdrawalAmountUnderLimit = (withdrawalAmount) => {
  return withdrawalAmount < 830;
};
